import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import { connect } from 'react-redux'
import { pingback } from '../shared/actions'
import * as selectors from 'shared/redux/reducers'
import { toggleEditMode, updateEditMode } from 'shared/redux/edit-mode'
import Explore from '../components/explore'

@connect(
    (state, props) => {
        const { groupId } = props

        return {
            searchResponseId: selectors.getResponseId(state),
            editMode: selectors.getEditMode(state),
            hasEnoughGifsForTV: selectors.hasEnoughGifsForTV(state, { ...props, groupId }),
            isSticker: state.searchType === 'sticker',
            error: selectors.getGifErrorByGroupId(state, { ...props, groupId }),
        }
    },
    dispatch => {
        return {
            pingback: (actions, responseId, pageType) => {
                dispatch(pingback(actions, responseId, pageType))
            },
            toggleEditMode: () => {
                dispatch(toggleEditMode())
            },
            updateEditMode: () => {
                dispatch(updateEditMode())
            },
        }
    }
)
export default class Container extends Explore {}
